/* eslint-disable jsx-a11y/media-has-caption */
import Viewer from '@micromag/viewer';
import classNames from 'classnames';
import React, { useMemo } from 'react';

import { useMicromagPreview } from '../../hooks/useMicromagPreview';
import useMicromagStory from '../../hooks/useMicromagStory';
import { useMicromagVideo } from '../../hooks/useMicromagVideo';

import { MicromagItem } from '../../types/micromag';
import Video from './Video';

import styles from '../../styles/partials/thumbnail.module.css';

function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

interface ThumbnailProps {
    micromag?: MicromagItem | null;
    withInfo?: boolean;
    /** Niveau de titre à utiliser, pour garder une hiérarchie cohérente (WCAG 1.3.1) */
    titleTag?: 'h1' | 'h2' | 'h3' | 'h4';
    isPoster?: boolean;
    autoPlay?: boolean;
    animated?: boolean;
    className?: string | null;
    innerClassName?: string | null;
}

const Thumbnail = ({
    micromag = null,
    withInfo = false,
    titleTag: TitleTag = 'h2',
    isPoster = false,
    autoPlay = true,
    animated = false,
    className = null,
    innerClassName = null,
}: ThumbnailProps) => {
    const { story = null, loading = false } = useMicromagStory(micromag);
    const { medias = [], thumbnail } = useMicromagVideo(story);
    const simpleStory = useMicromagPreview(story);
    const { title = null, description = null } = simpleStory || {};

    const descriptionLines = useMemo(() => {
        if (description === null) {
            return [];
        }
        var index = description.lastIndexOf(',');
        var first = description.substr(0, index);
        var last = description.substr(index + 1);
        return (
            [first, last]
                // .split(/,|et/)
                // .split(',')
                .map((line) => line.trim())
                .filter((line) => line.length > 0)
                .map(capitalizeFirstLetter)
        );
    }, [description]);

    // console.log('story', story, micromag);

    return (
        <div className={classNames(styles.container, className)}>
            {(medias !== null && medias.length > 0) || thumbnail !== null ? (
                <Video
                    className={classNames([styles.video, innerClassName])}
                    medias={medias}
                    thumbnail={thumbnail}
                    isPoster={isPoster}
                    autoPlay={autoPlay}
                    animated={animated}
                />
            ) : (
                <Viewer
                    story={simpleStory}
                    className={classNames([styles.video, innerClassName])}
                    withoutMenu
                    withoutGestures
                    withoutNavigationArrow
                    withNavigationHint={false}
                    withoutPlaybackControls
                />
            )}
            {withInfo ? (
                <div className={styles.info}>
                    <TitleTag className={styles.title}>{title || 'Sans titre'}</TitleTag>
                    <p className={styles.description}>
                        {description}
                        {/* {descriptionLines.map((line, index) => (
                            <span className={styles.line} key={index}>
                                {line}
                            </span>
                        ))} */}
                    </p>
                </div>
            ) : (
                /*
                 * Sans bloc d'information, la vignette ne contient qu'une vidéo :
                 * le lien qui l'entoure n'aurait aucun nom accessible
                 * (WCAG 2.4.4 / 4.1.2).
                 */
                <span className="visually-hidden">{title || 'Sans titre'}</span>
            )}
        </div>
    );
};

export default Thumbnail;
